import { useTranslation as useI18nextTranslation, } from 'react-i18next';
import { DEFAULT_NAMESPACE } from './config.js';
/**
 * `useTranslation` narrowed to the eight namespaces, so a typo in a namespace
 * name is a type error rather than a silently missing bundle.
 *
 * One namespace per call by design (docs/011-i18n.md): a component belongs to
 * one area, and cross-namespace strings carry the prefix — `t('common:actions.save')`.
 */
export function useTranslation(namespace = DEFAULT_NAMESPACE) {
    return useI18nextTranslation(namespace);
}
//# sourceMappingURL=use-translation.js.map